import { useEffect } from 'react';
import './responsive-tables.css';

const esElegible = (table) => {
  if (table.closest('.no-stack')) return false;
  if (
    table.closest('.mdxeditor') ||
    table.closest('.w-md-editor') ||
    table.closest('.wmde-markdown')
  ) {
    return false;
  }
  if (table.querySelector('input, select, textarea')) return false;
  return true;
};

const etiquetar = (table) => {
  if (table.dataset.rt === '1' || !esElegible(table)) return;
  const heads = Array.from(table.querySelectorAll('thead th')).filter(
    (th) => !th.querySelector('input, select, textarea')
  );
  if (heads.length === 0) return;

  const filas = Array.from(table.querySelectorAll('tbody tr'));
  filas.forEach((tr) => {
    if (tr.querySelector('input, select, textarea')) return;
    const celdas = Array.from(tr.querySelectorAll('td'));
    celdas.forEach((td, i) => {
      if (td.colSpan > 1 || td.rowSpan > 1) return;
      const th = heads[i];
      if (th && th.innerText.trim()) {
        td.setAttribute('data-label', th.innerText.trim());
      }
    });
  });
  table.classList.add('rt-table');
  table.dataset.rt = '1';
};

let iniciado = false;

export const useResponsiveTables = () => {
  useEffect(() => {
    if (iniciado) return;
    iniciado = true;

    const procesar = () => {
      document.querySelectorAll('table').forEach((t) => etiquetar(t));
    };

    let timer = null;
    const observer = new MutationObserver(() => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(procesar, 150);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    procesar();

    return () => {
      observer.disconnect();
      if (timer) clearTimeout(timer);
    };
  }, []);
};
